import { render } from "./playSound.vue?vue&type=template&id=66c9c3bc"
import script from "./playSound.vue?vue&type=script&lang=js"
export * from "./playSound.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\humanbrainview\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__